import i18n from '../i18n/config';

/**
 * Utility function to translate tier names from English to the current language.
 * `titleCase` returns the Title Case variant ("Gold", "Débutant") instead of the stored ALL-CAPS one.
 */
export const translateTierName = (tierName: string, { titleCase = false }: { titleCase?: boolean } = {}) => {
  if (!tierName) return '';

  const normalizedTierName = tierName.toLowerCase();

  switch (normalizedTierName) {
    case 'entry':
      return i18n.t(titleCase ? 'tiersTitleCase.entry' : 'tiers.entry');
    case 'bronze':
      return i18n.t(titleCase ? 'tiersTitleCase.bronze' : 'tiers.bronze');
    case 'silver':
      return i18n.t(titleCase ? 'tiersTitleCase.silver' : 'tiers.silver');
    case 'gold':
      return i18n.t(titleCase ? 'tiersTitleCase.gold' : 'tiers.gold');
    case 'diamond':
      return i18n.t(titleCase ? 'tiersTitleCase.diamond' : 'tiers.diamond');
    case 'emerald':
      return i18n.t(titleCase ? 'tiersTitleCase.emerald' : 'tiers.emerald');
    case 'pearl':
      return i18n.t(titleCase ? 'tiersTitleCase.pearl' : 'tiers.pearl');
    case 'dynasty':
      return i18n.t(titleCase ? 'tiersTitleCase.dynasty' : 'tiers.dynasty');
    default:
      // Fallback to original name if no translation found
      return tierName;
  }
};
